import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { GasOilAndLubricantTypeService } from '../proxy/general/controllers/gas-oil-and-lubricant-type.service';
import { GasOilProviderService } from '../proxy/general/controllers/gas-oil-provider.service';
import { ConsumableService } from '../proxy/general/controllers/consumable.service';

FieldBuilder.setNamespace('General');

export const GASOILANDLUBRICANT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('gasOilAndLubricantTypeId', 'Entity.GasOilAndLubricantType', GasOilAndLubricantTypeService)
    .required()
    .displayFromNested('gasOilAndLubricantType.name')
    .sortBy('gasOilAndLubricantType.name')
    .build(),
  FieldBuilder
    .foreignKey('gasOilProviderId', 'Entity.GasOilProvider', GasOilProviderService)
    .displayFromNested('gasOilProvider.name')
    .sortBy('gasOilProvider.name')
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.Consumable', ConsumableService)
    .required()
    .displayFromNested('consumable.name')
    .sortBy('consumable.name')
    .hideInChildForms()
    .build(),
];

export const GASOILANDLUBRICANT_CONFIG = {
  entityName: 'GasOilAndLubricant',
  localizationKey: 'General::Entity.GasOilAndLubricant',
  fields: GASOILANDLUBRICANT_FIELDS,
  permission: 'General.GasOilAndLubricants',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,

};
